<template>
  <div class="container-12 body">
    <div class="row justify-content-center">
      <div class="col-11 col-sm-8">
        <div class="py-3 text-center">
          <h3 class="title">予約完了</h3>
        </div>
        <div class= "border bg-light p-3">
          <div class="row text-center mb-3">
            <div class="col">予約が完了しました</div>
          </div>
          <div class="row text-center">
            <div class="col"><button type="button" class="btn btn-primary w-75" @click="roomListClick()">予約一覧画面へ</button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reserveMixin from '@/mixins/reserveMixin.js'
import authMixins from '@/mixins/authMixin.js'

export default {
  name: 'ReserveComplete',

  created() {
    // ストアに予約情報が存在しない場合、予約一覧画面へ遷移
    this.transitionRoomList();
    // ストアの予約情報を初期化
    this.$store.dispatch('clearItem');
    this.$store.dispatch('clearReserveDate');
    this.$store.dispatch('clearReserveTimes');
    this.$store.dispatch('clearPersonNum');
    this.$store.dispatch('clearVisiters');
  },
  methods: {
    roomListClick: function() {
      // 予約一覧画面へ遷移
      this.$router.push({ name: 'roomList' });
    },
  },
  mixins: [reserveMixin, authMixins],
}
</script>

<style scoped>
.body {
  padding-top: 128px;
}
</style>
